import { Store } from 'Application/Store/Store'




/*****************************************************************
 * LAYER HANDLER
 * ***************************************************************/

/**
 * Retrieve index of specific arch
 * @param {string} type
 * @returns number
 */
const
    matrix = {
        mandi: 1,
        maxi: 0,
        comparativeMaxi: 2,
        comparativeMandi: 3,
        malocMaxi: 4,
        malocMandi:5,
        setupMaxi:6,
        setupMandi:7,
    },
    getLayer = type => matrix[type]

/**
 * Assign Renderlayer to Mesh
 * @param {object} mesh
 * @param {string} layer
 */
export const setMeshToLayer = (mesh, layer) => mesh.layers.set(getLayer(layer))

export const addMeshToLayer = (mesh, layer) => mesh.layers.enable(getLayer(layer))
/**
 * Assign Default layer for specified camera
 * @param {object} camera
 */
export const setCameraToLayer = (camera) => {
    const { mainViewerLayer, comparativeViewerLeftLayer, comparativeViewerRightLayer } = Store.getState().ViewportReducer;

    const disableMany = (layers) => {
        camera.layers.enableAll();
        layers.forEach(l => camera.layers.disable(matrix[l]));
    };

    switch (camera.name) {
        case 'MainCamera':
            switch (mainViewerLayer) {
                case 'all':
                    switch (comparativeViewerRightLayer) {
                        case 'maloc':
                            disableMany(['mandi','maxi','comparativeMandi','comparativeMaxi','setupMaxi','setupMandi']);
                            break;
                        case 'version':
                            disableMany(['comparativeMandi','comparativeMaxi','malocMandi','malocMaxi','setupMaxi','setupMandi']);
                            break;
                        case 'setup':
                            disableMany(['mandi','maxi','malocMandi','malocMaxi','comparativeMandi','comparativeMaxi']);
                            break;
                        default:
                            disableMany(['setupMaxi','setupMandi','malocMandi','malocMaxi','comparativeMandi','comparativeMaxi']);
                            break;
                    }
                    break;

                case 'none':
                    camera.layers.disableAll();
                    break;

                case 'mandi':
                    switch (comparativeViewerRightLayer) {
                        case 'maloc': camera.layers.set(matrix['malocMandi']); break;
                        case 'version': camera.layers.set(matrix['mandi']); break;
                        case 'setup': camera.layers.set(matrix['setupMandi']); break;
                        default: camera.layers.set(matrix['mandi']); break;
                    }
                    break;

                case 'maxi':
                    switch (comparativeViewerRightLayer) {
                        case 'maloc': camera.layers.set(matrix['malocMaxi']); break;
                        case 'version': camera.layers.set(matrix['maxi']); break;
                        case 'setup': camera.layers.set(matrix['setupMaxi']); break;
                        default: camera.layers.set(matrix['maxi']); break;
                    }
                    break;

                default:
                    disableMany(['comparativeMandi','comparativeMaxi']);
                    break;
            }
            break;

        case 'TopCamera':
            camera.layers.set(1);
            break;

        case 'BottomCamera':
            camera.layers.set(0);
            break;

        case 'FrontCamera':
            disableMany(['comparativeMandi','comparativeMaxi','setupMaxi','setupMandi','malocMandi','malocMaxi']);
            break;

        case 'ComparativeCamera':
            switch (mainViewerLayer) {
                case 'all':
                    switch (comparativeViewerLeftLayer) {
                        case 'maloc':
                            disableMany(['mandi','maxi','comparativeMandi','comparativeMaxi','setupMaxi','setupMandi']);
                            break;
                        case 'version':
                            disableMany(['mandi','maxi','malocMandi','malocMaxi','setupMaxi','setupMandi']);
                            break;
                        case 'setup':
                            disableMany(['mandi','maxi','malocMandi','malocMaxi','comparativeMandi','comparativeMaxi']);
                            break;
                        default:
                            disableMany(['mandi','maxi','malocMandi','malocMaxi','comparativeMandi','comparativeMaxi']);
                            break;
                    }
                    break;

                case 'none':
                    camera.layers.disableAll();
                    break;

                case 'maxi':
                    switch (comparativeViewerLeftLayer) {
                        case 'maloc': camera.layers.set(matrix['malocMaxi']); break;
                        case 'version': camera.layers.set(matrix['comparativeMaxi']); break;
                        case 'setup': camera.layers.set(matrix['setupMaxi']); break;
                        default: camera.layers.set(matrix['malocMaxi']); break;
                    }
                    break;

                case 'mandi':
                    switch (comparativeViewerLeftLayer) {
                        case 'maloc': camera.layers.set(matrix['malocMandi']); break;
                        case 'version': camera.layers.set(matrix['comparativeMandi']); break;
                        case 'setup': camera.layers.set(matrix['setupMandi']); break;
                        default: camera.layers.set(matrix['malocMandi']); break;
                    }
                    break;

                default:
                    switch (comparativeViewerLeftLayer) {
                        case 'maloc': disableMany(['mandi','maxi','comparativeMandi','comparativeMaxi']); break;
                        case 'version': disableMany(['mandi','maxi','malocMandi','malocMaxi']); break;
                        default: disableMany(['mandi','maxi','comparativeMandi','comparativeMaxi']); break;
                    }
                    break;
            }
            break;

        default:
            disableMany(['comparativeMandi','comparativeMaxi']);
            break;
    }
};

/**
 * Assign Renderlayer for LightSetup
 * @param {object} lightSetup
 */
export const setLightSetupLayer = lightSetup => {
    lightSetup.children.forEach(light =>
        Object.values(matrix).forEach(layer =>
            light.layers.enable(layer)
        )
    )
}
